"use client";

var _excluded = ["align", "size", "component", "fontType", "color", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import requiredIf from "react-required-if";
import { headingColor, serifFont, sansSerifFont, h1FontFamily, h1FontSize, h1FontWeight, h1Tracking, h1LineHeight, h1IsUpperCase, h2FontFamily, h2FontSize, h2FontWeight, h2Tracking, h2LineHeight, h2IsUpperCase, h3FontFamily, h3FontSize, h3FontWeight, h3Tracking, h3LineHeight, h3IsUpperCase, h4FontFamily, h4FontSize, h4FontWeight, h4Tracking, h4LineHeight, h4IsUpperCase, h5FontFamily, h5FontSize, h5FontWeight, h5Tracking, h5LineHeight, h5IsUpperCase, h6FontFamily, h6FontSize, h6FontWeight, h6Tracking, h6LineHeight, h6IsUpperCase } from "@nib-components/theme";
import { color as getColor, map, validColorValues } from "@nib/layout";
export var validSizeValues = [1, 2, 3, 4, 5, 6];
export var validComponentValues = ["h1", "h2", "h3", "h4", "h5", "h6", "div", "label", "span", "header", "p"];
var validBreakpointValues = ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"];
var validFontTypeValues = ["serif", "sans-serif"];
export var validAlignValues = ["left", "center", "right"];
export var h1 = function h1() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n"])), h1FontFamily, h1FontSize, h1FontWeight, h1Tracking, h1LineHeight, function (props) {
    return h1IsUpperCase(props) && "text-transform: uppercase;";
  });
};
export var h2 = function h2() {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n"])), h2FontFamily, h2FontSize, h2FontWeight, h2Tracking, h2LineHeight, function (props) {
    return h2IsUpperCase(props) && "text-transform: uppercase;";
  });
};

var h3 = function h3() {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n"])), h3FontFamily, h3FontSize, h3FontWeight, h3Tracking, h3LineHeight, function (props) {
    return h3IsUpperCase(props) && "text-transform: uppercase;";
  });
};

var h4 = function h4() {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n"])), h4FontFamily, h4FontSize, h4FontWeight, h4Tracking, h4LineHeight, function (props) {
    return h4IsUpperCase(props) && "text-transform: uppercase;";
  });
};

var h5 = function h5() {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n"])), h5FontFamily, h5FontSize, h5FontWeight, h5Tracking, h5LineHeight, function (props) {
    return h5IsUpperCase(props) && "text-transform: uppercase;";
  });
};

var h6 = function h6() {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  ", ";\n"])), h6FontFamily, h6FontSize, h6FontWeight, h6Tracking, h6LineHeight, function (props) {
    return h6IsUpperCase(props) && "text-transform: uppercase;";
  });
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


export var BaseHeadingComponent = function BaseHeadingComponent(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var align = props.align,
      size = props.size,
      component = props.component,
      fontType = props.fontType,
      color = props.color,
      children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded); // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var Component = component; // if size is a number, we can infer the component

  if (!Component && typeof size === "number") {
    Component = "h".concat(size);
  } //eslint-disable-next-line no-undef


  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var invariant = require("invariant");

    invariant(Component || typeof size === "number", "@nib-components/heading: Must have component prop set if size prop is an object.");
  }

  return /*#__PURE__*/React.createElement(Component, otherProps, children);
};

var isNamedColor = function isNamedColor(color) {
  if (!color) return false;

  if (validColorValues.includes(color)) {
    return true;
  }

  return false;
};

var setColor = function setColor(props) {
  if (isNamedColor(props.color)) {
    return getColor(props);
  } // Else return the old color behavior (selector or raw string)


  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), props.color || headingColor);
};

var Heading = styled(BaseHeadingComponent)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 0;\n\n  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", ";\n"])), function (props) {
  return setColor(_objectSpread(_objectSpread({}, props), {}, {
    color: props.color
  }));
}, function (_ref) {
  var size = _ref.size;
  return size && map(size, function (val) {
    if (val === 1) return h1();
    if (val === 2) return h2();
    if (val === 3) return h3();
    if (val === 4) return h4();
    if (val === 5) return h5();
    if (val === 6) return h6();
  });
}, function (_ref2) {
  var align = _ref2.align;
  return map(align, function (val) {
    if (align) {
      return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n          text-align: ", ";\n        "])), val);
    }

    return "";
  });
}, function (_ref3) {
  var theme = _ref3.theme,
      fontType = _ref3.fontType;
  return fontType ? theme.id === "nib" ? fontType === "sans-serif" ? css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n              &&& {\n                font-family: ", ";\n                font-weight: 700;\n              }\n            "])), sansSerifFont) : css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n              &&& {\n                font-family: ", ";\n                font-weight: 600;\n              }\n            "])), serifFont) : "" : "";
});
Heading.propTypes = {
  size: PropTypes.oneOfType([PropTypes.oneOf(validSizeValues), PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    xxl: PropTypes.number,
    xxxl: PropTypes.number
  })]).isRequired,
  component: requiredIf(PropTypes.oneOfType([PropTypes.string, PropTypes.func]), function (props) {
    return _typeof(props.size) === "object";
  }),
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  fontType: PropTypes.oneOf(validFontTypeValues),
  children: PropTypes.node
};
Heading.displayName = "Heading";
export default Heading;